<template>
		<div>                          
            <div class="owl-carousel-recommended">   
				<div v-for="product in allProducts" class="recommended-product-container">
                    <div class="product__container-recommended">
                        <div class="product-image__container-recommended">
                            <img :src="imageDir + '/products/' + product.IMAGE" :alt="product.NAME" class="product-image">
                        </div>
						<div class="product-title__recommended">
                            <div class="product__name_recommended">{{ product.NAME }}</div>
                        </div>
                        <div class="product-info__container-recommended">
                            <span v-html="product.LIST_ITEMS"></span>
                        </div>
                        <div class="product-btns__container-recommended">
							<div class="product-price__recommended" v-if="membership>=1">${{ productData[product.PRODUCT_ID].price }}</div>
							<div class="product-price__recommended" v-else>${{ productData[product.PRODUCT_ID].retailPrice }}</div>	
                            <button class="btn btn-success order-now-btn" :onclick="'openAddToCartPopup(' + product.PRODUCT_ID + ')'"><i class="fas fa-shopping-cart"></i> Add to Cart</button>
                        </div>
                    </div>
				</div>
        	</div>
		</div>	
</template>

<script lang="ts">
    export default {
        props: {
			productDataJson: String,
			allProductPages: String,
			packProducts: String,
			packs:String,
			isLoggedIn: Boolean,
			isPreenrollee: Boolean,
         	scriptName: String,
         	openCartInitially: Boolean,
         	coupon: Number,
         	enrollerFirst: String,
         	retailOnly:Number,
			imageDir: String
            /* products: Array */
        },
		watch: {
			isOpen: function(isOpen) {
				if (isOpen) {
					jQuery("#myModal2").modal('show')
				} else {
					jQuery("#myModal2").modal('hide')
				}
			}
		},
		data: function () {
			return {
				isOpen: false,
				bvModalIsOpen: false,
				items: [],
				products: [],
				selectedProducts: [],
				notifications: [],
				totalPrice: '0',
				retailTotalPrice: '0',
				totalBV: 0,
				countryCode: '',
				percentSavings: 0,
				percentOffName: '',
				percentSavingsSecond: 0,
				percentOffNameSecond: '',
            	totalMemberSave: '0',
            	membership:0,
            	couponAmount:0,
            	shippingOrderCount:0
			}
		},
		methods: {
			isSpecialPackSubProduct(id) {
				return /\d+_\d+/.test(id)
			},
			mapItemsToProductMeta: function () {
				let vm = this;
				let products = [];
				let selectedProducts = [];
				let subProducts = []
				let freeCounts = new Map();
				this.items.forEach(function (item) {
					if (item.free) {
						let productId = item.productId.replace("FREE_", "");
						freeCounts[productId] = item.quantity;
						item.productId = productId
					}
				});
				this.items.forEach((item) => {
					if (this.isSpecialPackSubProduct(item.productId)) {
						item = {
							...item, 
							isSpecialPackSubProduct: true,
							productId: String(item.productId).match(/\d+_(?<subpid>\d+)/).groups.subpid
						}
					}
					if (vm.productData[item.productId]) {
						let product = {
							'id': item.productId,
							'name': vm.productData[item.productId].name,
							'price': vm.productData[item.productId].price,
                            'retailPrice': vm.productData[item.productId].retailPrice,
							'bv': vm.productData[item.productId].bv,
							'quantity': item.quantity,
							'free': item.free,
							'freeCount': freeCounts[item.productId],
							'image': vm.productData[item.productId].image,
							'max': parseInt(vm.productData[item.productId].max, 10),
							'product_months': vm.productData[item.productId].product_months,
							'monthly_bv': vm.productData[item.productId].monthly_bv,
							'sale': vm.productData[item.productId].sale,
				         	'saleMessage': vm.productData[item.productId].saleMessage,
							'salePrice': vm.productData[item.productId].salePrice,
							'isSpecialPackMainProduct': vm.productData[item.productId].isSpecialPackMainProduct,
							'isSpecialPackSubProduct': item.isSpecialPackSubProduct,
							'allowAutoship': (this.isLoggedIn && !this.isPreenrollee) && vm.productData[item.productId].allowAutoship,
							'autoship': item.autoship
						};

						if (vm.productData[item.productId].flavor) {
							product['flavor'] = vm.productData[item.productId].flavor;
						}

						if (vm.productData[item.productId].size) {
							product['size'] = vm.productData[item.productId].size;
						}
						if (vm.productData[item.productId].promoCartMessage) {
							product['promoCartMessage'] = vm.productData[item.productId].promoCartMessage;
						}
						if (vm.productData[item.productId].promoCartMessageLine2) {
							product['promoCartMessageLine2'] = vm.productData[item.productId].promoCartMessageLine2;
						}
						products.push(product);
						if (product['quantity'] >=1) {
							selectedProducts.push(product.id)
							if (this.packIds.includes(product.id)) {
								console.log('looking at pack ' + product.id)
								for (let packProduct of this.packsProductIds.filter(p => p.PACK_ID == product.id)) {
									console.log('for pack ' + product.id + ' going to add ' + packProduct.PRODUCT_ID)
									selectedProducts.push(packProduct.PRODUCT_ID)
								}
							}
						}
					}
				});

				this.items	
					.map(p => String(p.productId).match(/(?<main>\d+)_(?<sub>\d+)/)?.groups)
					.filter(p => p)
					.map(m => ({
						...m, 
						sub: products.find(({id}) => id == m.sub)
					}))
					.forEach(({main, sub}) => {
						const p = products.find(({id}) => id == main)
						p.specialPackSubProducts = p.specialPackSubProducts
							? p.specialPackSubProducts.concat(sub)
							: [sub]
					})

				this.products = products;
				this.selectedProducts = selectedProducts;
			},
			closeCart: function (e) {
				this.updateShoppingCartCount();
				this.isOpen = false;
			},
			getProducts: async function () {
				let vm = this;

				await shoppingCart.get().then(
					function (data) {
						vm.items = data.shoppingCartDetails || [];
						vm.mapItemsToProductMeta();
						vm.notifications = data.notifications || [];
						vm.totalPrice = Number(data.amount || 0).toFixed(2);
						vm.retailTotalPrice = Number(data.retailAmount || 0).toFixed(2);
						vm.totalBV = data.bv || 0;
						vm.countryCode = data.country;
						vm.percentSavings = Number(data.percentSavings).toFixed(2)
						vm.percentOffName = data.percentOffName
						vm.percentSavingsSecond = Number(data.percentSavingsSecond).toFixed(2)
						vm.percentOffNameSecond = data.percentOffNameSecond
                  		vm.couponAmount = Number(data.couponAmount || 0).toFixed(2)
                  		vm.shippingOrderCount =Number(data.shippingOrderCount ||0)
                  		if (vm.couponAmount>0 && vm.shippingOrderCount >0 && data.amount>0) {
                     		vm.totalPrice = Number(data.amount - vm.couponAmount ||0).toFixed(2);
                     		vm.retailTotalPrice = Number(data.retailAmount - vm.couponAmount ||0).toFixed(2);                             
                  		}
                        vm.totalMemberSave = Number(data.totalMemberSave  || 0).toFixed(2);
                        vm.membership = data.membership || 0;
					}
				);
			},
			changeProduct({
				id: productID, 
				quantity, 
				autoship,
				isSpecialPackMainProduct, 
				specialPackSubProducts
			}) {
				let vm = this;

				Promise.all(
					[productID].concat(
						isSpecialPackMainProduct
							? specialPackSubProducts
								.map(({id}) => `${productID}_${id}`)
							: []
					)
					.map(id => shoppingCart
						.setProduct(id, {quantity, autoship})
					)
				)
				.then(shoppingCart.get)
				.then(data => {
					vm.items = data.shoppingCartDetails || [];
					vm.mapItemsToProductMeta();
					vm.notifications = data.notifications || [];
					vm.totalPrice = Number(data.amount || 0).toFixed(2);
					vm.retailTotalPrice = Number(data.retailAmount || 0).toFixed(2);
					vm.totalBV = data.bv || 0;
					vm.percentSavings = Number(data.percentSavings).toFixed(2)
					vm.percentOffName = data.percentOffName
					vm.percentSavingsSecond = Number(data.percentSavingsSecond).toFixed(2)
					vm.percentOffNameSecond = data.percentOffNameSecond
	                vm.couponAmount = Number(data.couponAmount || 0).toFixed(2);
  		            vm.shippingOrderCount =  Number(data.shippingOrderCount || 0)
                  	if (vm.couponAmount>0 && vm.shippingOrderCount >0 && data.amount>0) {
                     	vm.totalPrice = Number(data.amount - vm.couponAmount ||0).toFixed(2);
                     	vm.retailTotalPrice = Number(data.retailAmount - vm.couponAmount ||0).toFixed(2);
                  	}
                    vm.totalMemberSave = Number(data.totalMemberSave || 0).toFixed(2);
                    vm.membership = data.membership || 0;
                    vm.tax = Number(data.tax || 0).toFixed(2)
				})
				
			},
			updateShoppingCartCount: function () {
				var openCart = document.getElementById('openCart'),
				openCartMobile = document.getElementById('openCartMobile'),
				className = 'shopping-cart-item-count',
				itemCount = 0;
				itemCount = this.productCount 
            	console.log("updating product Counts",this.productCount)
				if (itemCount > 0) {
					if (openCart.getElementsByClassName(className).length == 0) {
						var cartCountSpan = document.createElement('span');
						cartCountSpan.className = className;
						cartCountSpan.textContent = itemCount;
						openCart.appendChild(cartCountSpan);
					} else {
						openCart.getElementsByClassName(className)[0].innerHTML = itemCount;
					}

					if (openCartMobile.getElementsByClassName(className).length == 0) {
					 	var cartCountSpan = document.createElement('span');
					 	cartCountSpan.className = className;
					 	cartCountSpan.textContent = itemCount;
					 	openCartMobile.appendChild(cartCountSpan);
					} else {
					 	openCartMobile.getElementsByClassName(className)[0].innerHTML = itemCount;
					}
				} else {
					if (openCart.getElementsByClassName(className).length > 0) {
						var cartCountSpan = openCart.getElementsByClassName(className)[0]
						cartCountSpan.parentNode.removeChild(cartCountSpan);
					}

					if (openCartMobile.getElementsByClassName(className).length > 0) {
					 	var cartCountSpan = openCartMobile.getElementsByClassName(className)[0]
					 	cartCountSpan.parentNode.removeChild(cartCountSpan);
					}
				}
			},
		},
		created: function () {
		},
        computed: {
			visibleProducts() {
				return this.products
					.filter(p => !p.isSpecialPackSubProduct)
			},
			//selectedProducts() {
				//return this.selectedProducts
			//},
			productData: function () {
				return JSON.parse(this.productDataJson)
			},
			allProducts: function() {
				return JSON.parse(this.allProductPages).filter(p => !this.selectedProducts.includes(p.PRODUCT_ID))
			},
			packsProductIds() {
				return JSON.parse(this.packProducts)
			},
			packIds: function () {
				return JSON.parse(this.packs)
			},
			productsLink: function () {
					return "/products"
			},
			productCount: function() {
				return this.products
					.filter(({free}) => !free)
					.filter(({isSpecialPackSubProduct: c}) => !c)
					.reduce((a, {quantity}) => a + Number(quantity), 0)
			},
			productFreeCount: function() {
				return this.products
					.filter(({isSpecialPackSubProduct: c}) => !c)
					.filter(({free}) => free)
					.reduce((a, {quantity}) => a + Number(quantity), 0)
			}
		},
		mounted: async function () {
			await this.getProducts()
			this.updateShoppingCartCount()
			var openCartBtn = document.getElementById('openCart')
				,openCartBtnMobile = document.getElementById('openCartMobile');

			let vm = this;


			openCartBtn.addEventListener("click", function () {
				vm.isOpen = true;
				vm.getProducts();
			});

			openCartBtnMobile.addEventListener("click", function () {
			 	vm.isOpen = true;
			 	vm.getProducts();
			});
            console.log("in created",this.openCartInitially)
            if (this.openCartInitially && !this.isOpen) {
                document.getElementById("openCart").click()
                console.log("cart should be opening")
            }
		}
    }

</script>

<style>
	.active {
		color: red;
		right: 0;
	}
	.flex-column {
		display: flex;
		flex-direction: column;
	}
	.space-between {
		justify-content: space-between;
	}
	.parent-height {
		max-height: 100%;
	}
	.fill {
		flex: 1;
	}
</style>
